<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.interfaces.pageMollie.title') }}
    </portal>
    <template v-if="config !== null">
      <card v-if="isEmpty(config.accessTokenExpiration)" :title="$t('admin.interfaces.pageMollie.card.register')" cols="12 6@desktop">
        <card-action :title="$t('admin.interfaces.pageMollie.cardActionRegisterMollie')" @click="registerMollie()" />
      </card>
      <card v-else :title="$t('admin.interfaces.pageMollie.card.general')" cols="12 6@desktop start-1">
        <!--        <card-badge :tooltip="$t('betaVersion.tooltip')">{{ $t('betaVersion.title') }}</card-badge>-->
        <hm-card-inner :full-size="true">
          <hm-col v-if="isEmpty(config.accessTokenExpiration)" cols="12">
            <span class="info-text info-text--full-size col-12 info-text--no-margin" v-html="$t('admin.interfaces.pageMollie.hintConnectMollie')"></span>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner>
          <hm-input-toggle :label="$t('admin.interfaces.pageMollie.enabled')"
                           :enabled-title="$t('enabled')"
                           :disabled-title="$t('disabled')"
                           :help="$t('admin.interfaces.pageMollie.enabled_help')"
                           :disabled="isEmpty(config.accessTokenExpiration)"
                           v-model="config.enabled"
                           cols="12 6@hd start-1"
                           name="enabled" />
          <hm-input-select v-model="config.onlineBookingProfileId" :label="$t('admin.interfaces.pageMollie.onlineBookingProfileId')" name="onlineBookingProfileId" cols="12@mobile 6@tablet start-1">
            <option v-for="item in config.profiles" :value="item.id" v-html="item.name"></option>
          </hm-input-select>
          <hm-input-select v-model="config.depositProfileId" :label="$t('admin.interfaces.pageMollie.depositProfileId')" name="depositProfileId" cols="12@mobile 6@tablet start-1">
            <option v-for="item in config.profiles" :value="item.id" v-html="item.name"></option>
          </hm-input-select>
        </hm-card-inner>
      </card>
    </template>
    <hm-floating-buttons>
      <hm-floating-button :throttle="3500"
                          :label="$t('admin.interfaces.pageMollie.actions.connect')"
                          icon="fill-connect"
                          color="orange"
                          @click="connect()" />
      <hm-floating-button :throttle="3500"
                          :label="$t('admin.interfaces.pageMollie.actions.refresh')"
                          icon="refresh"
                          color="green"
                          @click="updateProfiles()" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import HmTextarea from '../../../lib/inputs/HmTextarea';
import HmTable from '../../../lib/table/HmTable';
import { isNil } from 'lodash';

export default {
  name: 'PageMollie',
  components: { HmTable, HmTextarea, HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      fn: function (cbSaveComplete) {
        this.axios.put(this.serviceUrls.interfaces.mollie.get(this, this.interfaceId), this.config)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
      interfaceId: this.$route.params.interfaceId,
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.mollie.get(this, null))
        .then((response) => {
          this.config = response.data.data;
        });
    },
    updateProfiles() {
      this.axios.post(this.serviceUrls.interfaces.mollie.updateProfiles(this, null))
        .then((response) => {
          this.loadData();
        });
    },
    connect() {
      this.axios.post(this.serviceUrls.interfaces.mollie.connect(this, null))
        .then((response) => {
          window.open(response.data.data.authorizationUrl, '_blank');
        });
    },
    registerMollie() {
      window.open(`https://www.mollie.com/dashboard/signup/3337954?lang=${this.$i18n.locale}`, '_blank');
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageMollie.vue